import { AutonomousCommunityDTO } from '@models/api/AutonomousCommunityDTO'
import { request } from '../request'

export const autonomousCommunities = {
  getAll: function () {
    return request.get<AutonomousCommunityDTO[]>('api/getCcaa')
  }
}
